export default __webpack_public_path__ + "static/media/min8.30e7586c.JPG";